module.exports = __webpack_public_path__ + "img/low_burger.39f30730.svg";